import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteDialog from "../../../components/modal/delete/DeleteDialog";
import baseUrl from "../../../../api/baseUrl";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import EventIcon from "@mui/icons-material/Event";

function TreatmentListTr({ item, setpreData, isMobile }: any) {
  const navigate = useNavigate();
  const [deleteOpen, setdeleteOpen] = useState(false);
  const [treatmentId, settreatmentId] = useState("");

  const onPreTrClick = (e: any) => {
    navigate(`/client/treatment-diagnose/add-treatment/diagnose/${e}`);
  };

  const onDelete = (e: any) => {
    setdeleteOpen(true);
    settreatmentId(e);
  };

  const confirmDelete = () => {
    if (treatmentId) {
      baseUrl
        .delete("/client/treatments/delete-treatement", {
          headers: { treatmentid: treatmentId },
        })
        .then((response) => {
          setdeleteOpen(false);
          setpreData((prevData: any) =>
            prevData.filter((item: any) => item._id !== treatmentId)
          );
          settreatmentId("");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const getStatusStyle = (status: string) => {
    switch (status) {
      case "ongoing":
        return { bg: "bg-amber-100 dark:bg-amber-900/30", text: "text-amber-700 dark:text-amber-300", dot: "bg-amber-500" };
      case "planned":
        return { bg: "bg-emerald-100 dark:bg-emerald-900/30", text: "text-emerald-700 dark:text-emerald-300", dot: "bg-emerald-500" };
      case "complete":
        return { bg: "bg-blue-100 dark:bg-blue-900/30", text: "text-blue-700 dark:text-blue-300", dot: "bg-blue-500" };
      default:
        return { bg: "bg-slate-100 dark:bg-slate-700", text: "text-slate-700 dark:text-slate-300", dot: "bg-slate-500" };
    }
  };

  const statusStyle = getStatusStyle(item?.status);

  // Mobile Card View
  if (isMobile) {
    return (
      <>
        <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-3 border border-slate-100 dark:border-slate-600">
          <div className="flex items-start justify-between mb-2">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 bg-gradient-to-br from-primary to-primaryLight rounded-full flex items-center justify-center text-white font-semibold text-xs">
                {item?.fullName?.charAt(0)?.toUpperCase()}
              </div>
              <div>
                <p className="font-semibold text-xs text-slate-800 dark:text-slate-200">{item?.fullName}</p>
                <span className="text-[10px] text-slate-500 dark:text-slate-400">{item?.regNo}</span>
              </div>
            </div>
            <span
              className={`px-1.5 py-0.5 rounded-md text-[10px] font-medium ${statusStyle.bg} ${statusStyle.text} capitalize`}
            >
              {item?.status}
            </span>
          </div>

          <div className="space-y-1.5 text-xs mb-2">
            <div className="flex items-center gap-1.5 text-slate-600 dark:text-slate-400">
              <PhoneIcon sx={{ fontSize: 14 }} className="text-slate-400 dark:text-slate-500" />
              <span>{item?.mobileNo}</span>
            </div>
            <div className="flex items-center gap-1.5 text-slate-600 dark:text-slate-400">
              <LocalHospitalIcon sx={{ fontSize: 14 }} className="text-slate-400 dark:text-slate-500" />
              <span>{item?.dentist}</span>
            </div>
            <div className="flex items-center gap-1.5 text-slate-600 dark:text-slate-400">
              <EventIcon sx={{ fontSize: 14 }} className="text-slate-400 dark:text-slate-500" />
              <span>{item?.updatedAt?.split("T")[0]}</span>
            </div>
          </div>

          <div className="flex gap-1.5 pt-2 border-t border-slate-200 dark:border-slate-600">
            <button
              onClick={() => onPreTrClick(item?._id)}
              className="flex-1 flex items-center justify-center gap-1 px-3 py-2 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg hover:shadow-lg hover:shadow-primary/20 transition-all text-xs font-medium"
            >
              <RemoveRedEyeIcon sx={{ fontSize: 14 }} />
              View
            </button>
            {!item?.notempty && (
              <button
                onClick={() => onDelete(item?._id)}
                className="p-2 bg-red-50 dark:bg-red-900/20 text-red-500 rounded-lg hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors"
              >
                <DeleteOutlineIcon sx={{ fontSize: 14 }} />
              </button>
            )}
          </div>
        </div>

        {deleteOpen && (
          <DeleteDialog
            onDelete={() => confirmDelete()}
            onCancel={() => setdeleteOpen(false)}
          />
        )}
      </>
    );
  }

  // Desktop Table Row
  return (
    <>
      <tr className="hover:bg-slate-50/50 dark:hover:bg-slate-700/50 transition-colors">
        <td className="px-3 py-2">
          <span className="px-2 py-0.5 text-[10px] font-semibold rounded-md bg-primary/10 dark:bg-primary/20 text-primary border border-primary/20 dark:border-primary/30">
            {item?.regNo}
          </span>
        </td>
        <td className="px-3 py-2">
          <div className="flex items-center gap-2.5">
            <div className="w-7 h-7 bg-gradient-to-br from-primary to-primaryLight rounded-full flex items-center justify-center text-white font-semibold text-[10px]">
              {item?.fullName?.charAt(0)?.toUpperCase()}
            </div>
            <span className="font-medium text-xs text-slate-800 dark:text-slate-200">{item?.fullName}</span>
          </div>
        </td>
        <td className="px-3 py-2 text-xs text-slate-600 dark:text-slate-400">{item?.mobileNo}</td>
        <td className="px-3 py-2 text-xs text-slate-600 dark:text-slate-400">{item?.dentist}</td>
        <td className="px-3 py-2">
          <div className="flex items-center gap-1.5">
            <div className={`w-1.5 h-1.5 rounded-full ${statusStyle.dot}`} />
            <span
              className={`px-2 py-0.5 rounded-md text-[10px] font-medium ${statusStyle.bg} ${statusStyle.text} capitalize`}
            >
              {item?.status}
            </span>
          </div>
        </td>
        <td className="px-3 py-2 text-xs text-slate-600 dark:text-slate-400">
          {item?.updatedAt?.split("T")[0]}
        </td>
        <td className="px-3 py-2">
          <div className="flex items-center gap-1.5">
            <button
              onClick={() => onPreTrClick(item?._id)}
              className="p-2 rounded-lg bg-primary/10 dark:bg-primary/20 text-primary hover:bg-primary/20 dark:hover:bg-primary/30 transition-colors"
              title="View"
            >
              <RemoveRedEyeIcon sx={{ fontSize: 14 }} />
            </button>
            {!item?.notempty && (
              <button
                onClick={() => onDelete(item?._id)}
                className="p-1.5 rounded-md bg-red-50 dark:bg-red-900/20 text-red-500 hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors"
                title="Delete"
              >
                <DeleteOutlineIcon sx={{ fontSize: 14 }} />
              </button>
            )}
          </div>
        </td>
      </tr>

      {deleteOpen && (
        <DeleteDialog
          onDelete={() => confirmDelete()}
          onCancel={() => setdeleteOpen(false)}
        />
      )}
    </>
  );
}

export default TreatmentListTr;
